import React, { Component } from 'react';
import { 
  Card,
  CardHeader,
  CardBody,
  Button,
  ListGroup,
  ListGroupItem,
  InputGroup,
  InputGroupAddon,
  Input,
  Pagination, 
  PaginationItem, 
  PaginationLink,
  Alert,
  Badge
} from 'reactstrap';
import numeral from 'numeral';

class Search extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: "",
      prefectures: null,
      origPrefectures: null,
      page: null,
      totalPages: null,
      origTotalPages: null,
      noSearchResults: false
    };
  }

  componentDidMount() {
    this.getFirstPage();
  }

  componentDidUpdate(prevProps) {
    const { coreInsight } = this.props; 

    if(coreInsight && coreInsight !== prevProps.coreInsight) {
      this.getFirstPage(); 
    }
  }

  getFirstPage() {
    const { coreInsight } = this.props;

    if(coreInsight) {
      fetch(coreInsight.endpoint + "/page/1").then((resp) => resp.json())
        .then((respJson) => {
          this.setState({ 
            prefectures: respJson.data,
            origPrefectures: respJson.data,
            page: 1,
            totalPages: respJson.total_pages,
            origTotalPages: respJson.total_pages
          });
        });
    }
  }

  handlePrevClick() {
    const { page } = this.state;
    const { coreInsight} = this.props;

    fetch(coreInsight.endpoint + "/page/" + (page - 1)).then((resp) => resp.json())
      .then((respJson) => {
        this.setState({ 
          prefectures: respJson.data,
          page: page - 1,
          noSearchResults: false
        });
      });
  }

  handleNextClick() {
    const { page } = this.state;
    const { coreInsight} = this.props;

    fetch(coreInsight.endpoint + "/page/" + (page + 1)).then((resp) => resp.json())
      .then((respJson) => {
        this.setState({ 
          prefectures: respJson.data,
          page: page + 1,
          noSearchResults: false
        });
      });
  }

  handleSearchChange(e) {
    if(e.target.value === "") {
      this.setState({ 
        search: e.target.value,
        prefectures: this.state.origPrefectures,
        page: 1,
        totalPages: this.state.origTotalPages,
        noSearchResults: false
      }); 
    } else {
      this.setState({ 
        search: e.target.value,
        noSearchResults: false
      }); 
    }
  }

  handleSearchClick() {
    const { coreInsight } = this.props;
    const { search } = this.state;

    fetch(coreInsight.endpoint + '/search/' + search)
      .then((resp) => resp.json())
      .then((respJson) => {
        if(respJson.data.length > 0) {
          this.setState({
            prefectures: respJson.data,
            page: 1,
            totalPages: respJson.total_pages,
            noSearchResults: false
          });
        } else {
          this.setState({
            prefectures: this.state.origPrefectures,
            page: 1,
            totalPages: this.state.origTotalPages,
            noSearchResults: true
          }); 
        }
      });
  }

  getDisplayValue(prefecture) {
    const { responseType } = this.props;
    let itemToDisplay = null;

    if(responseType === "interval") {
      let color = "success";

      switch(prefecture.interval) {
        case "high":      color = "danger";
                          break;
        case "medium":    color = "secondary";
                          break;
        case "moderate":  color="warning";
                          break;
        default:          break;
      }

      itemToDisplay = <Badge color={color} pill className="text-white">{this.formatValue(prefecture.value)}</Badge>;
    } else {
      itemToDisplay = <span className="text-muted">{this.formatValue(prefecture.value)}</span>; 
    }

    return itemToDisplay;
  }

  formatValue(value) {
    let numVal = numeral(value);
    return numVal.format('0,0.[00]');
  }

  render() {
    const { coreInsightId } = this.props;

    let searchResults = [];
    if(this.state.prefectures) {
      searchResults = this.state.prefectures.map((value) => {
        return (
          <ListGroupItem key={value.id} className="d-flex justify-content-between">
            <span>{value.name}&nbsp;&nbsp;{this.getDisplayValue(value)}</span>
            <Button 
              color="primary" 
              tag="a"
              size="sm" 
              href={"/core_insights/insight/" + coreInsightId + "/prefecture/" + value.id}
              outline>
              Select
            </Button>
          </ListGroupItem>
        ); 
      }); 
    }

    return (
      <Card className="mb-3">
        <CardHeader className="bg-primary text-white">Search For A Prefecture</CardHeader>
        <CardBody>
          { this.state.noSearchResults ? <Alert color="danger">No search results found.</Alert> : null }
          <InputGroup>
            <Input 
              value={this.state.search}
              onChange={this.handleSearchChange.bind(this)}
              placeholder="Search prefectures" />
            <InputGroupAddon addonType="append">
              <Button 
                onClick={this.handleSearchClick.bind(this)}
                color="primary">
                Search
              </Button>
            </InputGroupAddon>
          </InputGroup>
          <hr/>
          <ListGroup>
            {searchResults}
          </ListGroup>
          <Pagination className="mt-3" listClassName="justify-content-center mb-0">
            <PaginationItem
              disabled={this.state.page === 1}>
              <PaginationLink
                onClick={this.handlePrevClick.bind(this)}>
                Previous
              </PaginationLink>
            </PaginationItem>
            <PaginationItem
              disabled={this.state.page === this.state.totalPages}>
              <PaginationLink
                onClick={this.handleNextClick.bind(this)}>
                Next
              </PaginationLink>
            </PaginationItem>
          </Pagination>
          <p className="text-center mt-2 mb-0">{this.state.page} / {this.state.totalPages}</p>
        </CardBody>
      </Card>
    );
  }
}

export default Search;
